import { Typography } from "antd";

const GearRental = () => (<Typography.Title level={2}>Coming Soon</Typography.Title>);

export default GearRental;
